import type { IStringMap } from "./types";

export enum SearchItemTypes {
  Author = "author",
  Collection = "collection",
  Tag = "tag",
  Art = "art",
  Publishing = "copyright_page",
  Genre = "genre",
  Series = "serie",
}

export enum KeyCodes {
  Enter = "Enter",
  ArrowUp = "ArrowUp",
  ArrowDown = "ArrowDown",
}

export enum SearchErrors {
  ShortValue = "Пожалуйста, введите три или более символа",
}

export enum ArtType {
  Text = "text_book",
  Audio = "audiobook",
  Podcast = "podcast",
  PodcastPart = "podcast_episode",
}

export const translatedArtTypes: IStringMap = {
  text_book: "Электронная книга",
  audiobook: "Аудиокнига",
  podcast: "Подкаст",
  podcast_episode: "Выпуск подкаста",
};
